import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ModalServiceContext } from "./../../ricos-context/ModalContext.js";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider.js";
import { PmNodeType } from "./../../_shared/pm-node-types.js";
import { useNodeAttrs } from "./../../_shared/use-node-attrs.js";
import { resolveColorsPalette } from "./../../wix-rich-content-common/index.js";
import { NewColorPicker } from "./../../ui-components/color-picker/new-color-picker/index.js";
const LinkPreviewColorPicker = ({
  modalId,
  nodeId,
  colorType,
  referenceElement,
  config,
  defaultColor,
  onColorSelected,
  onColorAdded: onColorAddedProp
}) => {
  const modalService = useContext(ModalServiceContext);
  const { t } = useContext(RicosContext);
  const { pmNodeAttrs } = useNodeAttrs(nodeId, PmNodeType.LINK_PREVIEW);
  const logBi = useBiNext({
    modalId,
    pluginId: "linkPreview",
    nodeId
  });
  const themeColors = resolveColorsPalette(
    config?.colors ? Object.values(config?.colors) : [],
    void 0,
    57
  );
  const getConfigColors = () => {
    switch (colorType) {
      case "backgroundColor":
        return config.getBackgroundColors?.();
      case "titleColor":
        return config.getTitleColors?.();
      case "subtitleColor":
        return config.getSubtitleColors?.();
      case "linkColor":
        return config.getLinkColors?.();
      case "borderColor":
        return config.getBorderColors?.();
      default:
        return [];
    }
  };
  const [customColors, setCustomColors] = useState(
    resolveColorsPalette(
      getConfigColors() ?? [],
      pmNodeAttrs?.styles?.[colorType] ?? defaultColor,
      57
    )
  );
  const onColorAdded = (color) => {
    onColorAddedProp(color);
    setCustomColors((prev) => [...prev, color]);
    onColorSelected(color);
  };
  const closeModal = () => modalService.closeModal(modalId);
  const onResetColor = () => onColorSelected(void 0);
  const currentColor = pmNodeAttrs?.styles?.[colorType]?.toUpperCase();
  return /* @__PURE__ */ React.createElement(
    NewColorPicker,
    {
      themeColors,
      customColors,
      currentColor,
      title: t("ButtonColourModal_Title"),
      closeModal,
      onColorSelected,
      onColorAdded,
      onResetColor,
      referenceElement,
      logBi
    }
  );
};
export {
  LinkPreviewColorPicker
};
//# sourceMappingURL=link-preview-color-picker.js.map
